import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Form, Modal, Button, Alert } from 'react-bootstrap';
import { FaPlus, FaCheck, FaThumbsUp, FaTimes, FaTrash, FaSortAmountUp, FaSortAmountDown, FaNewspaper, FaArrowLeft, FaArrowRight, FaEye, FaDownload } from 'react-icons/fa';
import Navbar from '../dashboard/navbar';
import Sidebar from '../dashboard/sidebar';
import useAuth from '../dashboard/useAuth';
import axios from 'axios';

const Historique_admin = ({ titre }) => {
    useAuth();
    const [examen, setExamen] = useState([]);
    const [expandedDescriptions, setExpandedDescriptions] = useState({});
    const [sortConfig, setSortConfig] = useState({ key: null, direction: null });
    const [searchTerm, setSearchTerm] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [showTelechargerModal, setShowTelechargerModal] = useState(false);
    const [error, setError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingRejet, setIsLoadingRejet] = useState(false);
    const [isLoadingApprouver, setIsLoadingApprouver] = useState(false);
    const [alertModal, setAlertModal] = useState({ message: '', type: '' });
    const [message, setMessage] = useState({ message: '', type: '' });
    const [showMessage, setShowMessage] = useState(false);
    const [fileType, setFileType] = useState("pdf");

    const [selectedExamen, setSelectedExamen] = useState(null);
    const [selectedExamenIds, setSelectedExamenIds] = useState(new Set()); // Pour la sélection multiple (uniquement pour approbation)

    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const user_id = localStorage.getItem('user_id');
    const navigate = useNavigate();

    const isAdmin = true;
    const produit = "ExamenBlanc";
    const produit_id = localStorage.getItem('produit_id');

    // le modal 
    const handleCloseModal = () => setShowModal(false);
    const handleShowModal = () => setShowModal(true); // Function to open the modal
    const [motif, setMotif] = useState('');

    const handleMotifChange = (event) => {
        setMotif(event.target.value);
    };

    // Utilisation de useEffect pour mettre à jour le titre de la page
    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Examen"; // Définit le titre de la page
        }
    }, [user_id]);

    // Marquer toutes les notifications d'un formulaire comme vues
    const marquerToutesVues = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/marquer-toutes-vues/${produit_id}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    is_admin: isAdmin,  // Passer isAdmin dans le corps de la requête
                    produit: produit
                }),
            });

            if (!response.ok) {
                throw new Error('Erreur lors de la requête');
            }

            const data = await response.json();
            console.log('Toutes les notifications marquées comme vues :', data);
        } catch (error) {
            console.error('Erreur dans marquerToutesVu:', error);
        }
    };
    useEffect(() => {
        marquerToutesVues();
    }, []);

    // Fetching examens data from API
    const fetchExamen = async () => {
        setIsLoading(true)
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + '/liste-examenblanc-administrateur/');
            const data = await response.json();
            if (response.ok) {
                setExamen(data);
            } else {
                console.error('Erreur lors de la récupération des examens', data);
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        } finally {
            setIsLoading(false)
        }
    };
    useEffect(() => {
        fetchExamen();
    }, []);

    // Gestion de la sélection multiple (uniquement pour approbation)
    const handleSelectExamen = (examenId) => {
        setSelectedExamenIds(prev => {
            const newSelection = new Set(prev);
            if (newSelection.has(examenId)) {
                newSelection.delete(examenId);
            } else {
                newSelection.add(examenId);
            }
            return newSelection;
        });
    };

    // Sélectionner/désélectionner tous les examens de la page courante
    const handleSelectAll = () => {
        if (selectedExamenIds.size === currentExamen.length) {
            // Si tous sont déjà sélectionnés, on désélectionne tout
            setSelectedExamenIds(new Set());
        } else {
            // Sinon on sélectionne tous les examens de la page courante
            const allIds = new Set(currentExamen.map(examen => examen.id));
            setSelectedExamenIds(allIds);
        }
    };

    // Obtenir les examens sélectionnés
    const getSelectedExamens = () => {
        return examen.filter(e => selectedExamenIds.has(e.id));
    };

    // Fonction pour approuver un examen individuel
    const handleApprouver = async (examen) => {
        if (!examen) return;
        setIsLoadingApprouver(true)

        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/approuver-examenblanc/${examen.id}/${examen.utilisateur}/`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ admin_id: user_id }),
            });

            if (response.ok) {
                console.log('Examen blanc approuvé avec succès');
                showAlert("Examen blanc approuvé avec succès !");
                await fetchExamen();
            } else {
                const errorData = await response.json();
                if (errorData.error) {
                    console.error('Erreur:', errorData.error);
                    setMessage(`${errorData.error}`, 'danger');
                    setShowMessage(true);
                    setTimeout(() => {
                        setShowMessage(false);
                    }, 10000);
                } else {
                    console.error('Erreur inconnue lors de l\'approbation de l\'examen blanc');
                    showAlert("Une erreur inconnue s'est produite.");
                }
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
            showAlert("Une erreur réseau est survenue lors de l'approbation !");
        }
        finally {
            setIsLoadingApprouver(false)
        }
    };

    const handleSubmitRejet = () => {
        if (!motif) {
            showAlertModal("Veuillez renseigner le motif de rejet", 'danger');
            return;
        }
        handleRejeter(motif);
    };

    // Fonction pour rejeter un examen individuel
    const handleRejeter = async (motif) => {
        if (!selectedExamen) return;
        setIsLoadingRejet(true)

        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/rejeter-examenblanc/${selectedExamen.id}/${selectedExamen.utilisateur}/`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ motif, admin_id: user_id }),
            });

            const data = await response.json();
            if (response.ok) {
                console.log('Examen blanc rejeté avec succès');
                handleCloseModal();
                showAlert("Examen blanc rejeté avec succès !");
                setMotif('');
                await fetchExamen();
            } else {
                const errorData = await response.json();
                if (errorData.error) {
                    console.error('Erreur:', errorData.error);
                    showAlert(`Erreur : ${errorData.error}`);
                } else {
                    console.error('Erreur inconnue lors du rejet de l\'examen blanc');
                    showAlert("Une erreur inconnue s'est produite.");
                }
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
            showAlert("Une erreur réseau est survenue lors de l'approbation !");
        }
        finally {
            setIsLoadingRejet(false)
        }
    };

    // Fonction pour approuver plusieurs examens

    const handleApprouverMultiple = async () => {
        const selectedExamens = getSelectedExamens();
        if (selectedExamens.length === 0) return;

        setIsLoadingApprouver(true);

        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/approuver-multiple-examensblanc/`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    examen_ids: selectedExamens.map(e => e.id),
                    admin_id: user_id
                }),
            });

            const data = await response.json();

            if (response.ok) {
                if (data.error_count === 0) {
                    showAlert(`${data.success_count} examen(s) approuvé(s) avec succès !`);
                } else {
                    showAlert(
                        `${data.success_count} examen(s) approuvé(s), ${data.error_count} erreur(s)`,
                        data.success_count > 0 ? 'warning' : 'danger'
                    );

                    // Afficher les erreurs détaillées si nécessaire
                    if (data.errors && data.errors.length > 0) {
                        console.error('Erreurs détaillées:', data.errors);
                    }
                }

                await fetchExamen();
                setSelectedExamenIds(new Set());

            } else {
                const errorData = await response.json();
                if (errorData.error) {
                    showAlert(`Erreur : ${errorData.error}`, 'danger');
                } else {
                    showAlert("Une erreur inconnue s'est produite.", 'danger');
                }
            }

        } catch (error) {
            console.error('Erreur réseau:', error);
            showAlert("Une erreur réseau est survenue lors de l'approbation !", 'danger');
        } finally {
            setIsLoadingApprouver(false);
        }
    };

    const [isLoadingTelechargement, setIsLoadingTelechargement] = useState(false);
    const handleTelecharger = async () => {
        if (!selectedExamen) return;

        setIsLoadingTelechargement(true)
        try {
            const response = await fetch(
                `${process.env.REACT_APP_HOTE}/telecharger-resultats/${selectedExamen.utilisateur}/${selectedExamen.id}/`,
                {
                    method: 'GET',
                    headers: {
                        'Accept': "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                    },
                }
            );

            if (!response.ok) {
                const errorText = await response.text();
                console.error("Erreur lors du téléchargement :", response.status, errorText);
                showAlert(`Erreur ${response.status}: ${errorText.substring(0, 100)}...`);
                return;
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `resultats_examen_${selectedExamen.id}_${new Date().toISOString().slice(0, 10)}.docx`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);

            window.URL.revokeObjectURL(url);
            setShowTelechargerModal(false)
            showAlert(`Téléchargement du fichier Word réussi !`);

        } catch (error) {
            console.error("Erreur réseau:", error);
            showAlert("Une erreur réseau est survenue lors du téléchargement !");
        } finally {
            setIsLoadingTelechargement(false)
        }
    };


    // Handle alerts
    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
            fetchExamen()
        }, 3000);
    };

    // Handle alerts modal
    const showAlertModal = (message, type = 'success') => {
        setAlertModal({ message, type });
        fetchExamen()
        setTimeout(() => {
            setAlertModal({ message: '', type: '' });
        }, 2000);
    };

    const handleRowClick = (examen) => {
        // Pour la sélection individuelle (rejet)
        setSelectedExamen(examen);

        // Pour la sélection multiple (approbation)
        handleSelectExamen(examen.id);
    };

    // Filter examens by search term
    const filteredExamen = examen.filter(e =>
        (e.nom && e.nom.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (e.date_demande && e.date_demande.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (e.date_examen && e.date_examen.toString().includes(searchTerm.toLowerCase())) ||
        (e.type_examen && e.type_examen.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (e.nbre_heures && e.nbre_heures.toString().includes(searchTerm)) ||
        (e.non_traite && e.non_traite.toString().toLowerCase().includes(searchTerm)) ||
        (e.statut && e.statut.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (e.motif && e.motif.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (e.pourcent && e.pourcent.toString().includes(searchTerm))
    );

    // Sort examens
    const sortedExamen = [...filteredExamen].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
    });

    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    // Pagination logic
    const indexOfLastExamen = currentPage * itemsPerPage;
    const indexOfFirstExamen = indexOfLastExamen - itemsPerPage;
    const currentExamen = sortedExamen.slice(indexOfFirstExamen, indexOfLastExamen);
    const totalPages = Math.ceil(sortedExamen.length / itemsPerPage);

    // Handle items per page change
    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    const handleToggleDescription = (id) => {
        setExpandedDescriptions((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));
    };

    const handleResultatExamen = () => {
        console.log(selectedExamen)
        if (selectedExamen) {
            navigate(`/Admin-Resultat-examen`, {
                state: { examen_id: selectedExamen.id, utilisateur_id: selectedExamen.utilisateur },
            });
        }
    };

    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}/`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupe(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupe.includes("AdminExamenBlanc")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                            <Link to="/" className="btn btn-primary">
                                                <i className="fa fa-arrow-left mr-2"></i>
                                                Retour
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className='d-flex align-items-center'><FaNewspaper size={25} className='mr-2' />Gestion des examens</h2>
                            <small>Administration des examens.</small>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/admin`}> Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Historique-admin`}> Examens</Link>
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>
                    <div className="mt-3">
                        <div className="wrapper wrapper-content animated fadeInRight">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5>Liste des examens</h5>
                                <div>
                                    {/* Bouton pour désélectionner tout */}
                                    {selectedExamenIds.size > 0 && (
                                        <button
                                            onClick={() => {
                                                setSelectedExamenIds(new Set());
                                                setSelectedExamen(null);
                                            }}
                                            className="btn ms-2 mr-2 mt-1 btn-outline-secondary"
                                        >
                                            Tout désélectionner ({selectedExamenIds.size})
                                        </button>
                                    )}

                                    {/* Boutons TOUJOURS VISIBLES maintenant */}

                                    {/* Bouton Approuver - toujours visible */}
                                    <button
                                        onClick={() => {
                                            if (selectedExamenIds.size > 1) {
                                                handleApprouverMultiple();
                                            } else if (selectedExamen) {
                                                handleApprouver(selectedExamen);
                                            }
                                        }}
                                        className={`btn ms-2 mr-2 mt-1 ${selectedExamenIds.size > 0 &&
                                            (!selectedExamen || (selectedExamen && selectedExamen.statut !== "Terminé" && selectedExamen.statut !== "Date d'examen dépassée"))
                                            ? 'btn-success'
                                            : 'btn-default text-dark'
                                            }`}
                                        disabled={
                                            selectedExamenIds.size === 0 ||
                                            (selectedExamenIds.size === 1 && selectedExamen &&
                                                (selectedExamen.statut === "Terminé" || selectedExamen.statut === "Date d'examen dépassée")) ||
                                            isLoadingApprouver
                                        }
                                    >
                                        <FaThumbsUp />
                                        <span className="d-none d-sm-inline ml-1">
                                            {isLoadingApprouver ? 'Approbation...' :
                                                selectedExamenIds.size > 1 ? `Approuver (${selectedExamenIds.size})` :
                                                    'Approuver'}
                                        </span>
                                    </button>

                                    {/* Bouton Rejeter - toujours visible */}
                                    <button
                                        onClick={handleShowModal}
                                        className={`btn ms-2 mr-2 mt-1 ${selectedExamen &&
                                            selectedExamenIds.size === 1 &&
                                            selectedExamen.statut !== "Terminé" &&
                                            selectedExamen.statut !== "Date d'examen dépassée"
                                            ? 'btn-success'
                                            : 'btn-default text-dark'
                                            }`}
                                        disabled={
                                            !selectedExamen ||
                                            selectedExamenIds.size !== 1 ||
                                            selectedExamen.statut === "Terminé" ||
                                            selectedExamen.statut === "Date d'examen dépassée" ||
                                            isLoadingRejet
                                        }
                                    >
                                        <FaTimes />
                                        <span className="d-none d-sm-inline ml-1">
                                            {isLoadingRejet ? 'Rejet...' : 'Rejeter'}
                                        </span>
                                    </button>

                                    {/* Bouton Détail - toujours visible */}
                                    <button
                                        onClick={handleResultatExamen}
                                        className={`btn ms-2 mt-1 mr-2 ${selectedExamen &&
                                            selectedExamenIds.size === 1 &&
                                            (selectedExamen.statut === "Termine" || selectedExamen.statut === "Terminé")
                                            ? 'btn-success'
                                            : 'btn-default text-dark'
                                            }`}
                                        disabled={
                                            !selectedExamen ||
                                            selectedExamenIds.size !== 1 ||
                                            !(selectedExamen.statut === "Termine" || selectedExamen.statut === "Terminé")
                                        }
                                    >
                                        <FaEye />
                                        <span className="d-none d-sm-inline ml-1">
                                            Détail
                                        </span>
                                    </button>

                                    {/* Bouton Télécharger - toujours visible */}
                                    {isLoadingTelechargement ? (
                                        <button className="btn btn-success mr-2" disabled>
                                            <i className="fa fa-spinner fa-spin mr-1"></i>
                                            <span className="d-none d-sm-inline ml-2">
                                                Chargement...
                                            </span>
                                        </button>
                                    ) : (
                                        <button
                                            onClick={() => handleTelecharger()}
                                            className={`btn ms-2 mt-1 ${selectedExamen &&
                                                selectedExamenIds.size === 1 &&
                                                selectedExamen.statut === "Termine"
                                                ? 'btn-success'
                                                : 'btn-default text-dark'
                                                }`}
                                            disabled={
                                                !selectedExamen ||
                                                selectedExamenIds.size !== 1 ||
                                                selectedExamen.statut !== "Termine"
                                            }
                                        >
                                            <FaDownload />
                                            <span className="d-none d-sm-inline ml-1">
                                                Télécharger
                                            </span>
                                        </button>
                                    )}
                                </div>
                            </div>

                            {/* Indicateur de sélection pour approbation multiple */}
                            {/* {selectedExamenIds.size > 0 && (
                                <div className="alert alert-info mb-3">
                                    <strong>{selectedExamenIds.size} examen(s) sélectionné(s) pour approbation multiple</strong>
                                </div>
                            )} */}

                            <Modal show={showModal} onHide={handleCloseModal}>
                                <Modal.Header>
                                    <Modal.Title>
                                        Rejeter l'examen
                                    </Modal.Title>
                                </Modal.Header>
                                {alertModal.message && (
                                    <div className={`m-3 alert alert-${alertModal.type}`}>
                                        {alertModal.message}
                                    </div>
                                )}
                                <Modal.Body>
                                    <Form.Group>
                                        <Form.Label>
                                            Motif du rejet :
                                        </Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            value={motif}
                                            onChange={handleMotifChange}
                                            placeholder="Motif du rejet"
                                            required
                                        />
                                    </Form.Group>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="default" onClick={handleCloseModal}>
                                        Annuler
                                    </Button>
                                    <Button
                                        variant="success"
                                        onClick={handleSubmitRejet}
                                        disabled={!motif.trim()}
                                    >
                                        Rejeter
                                    </Button>
                                </Modal.Footer>
                            </Modal>

                            {alert.message && (
                                <div className={`alert alert-${alert.type}`}>
                                    {alert.message}
                                </div>
                            )}
                            {showMessage && (
                                <Alert variant="success" className={`alert alert-danger`} onClose={() => setShowMessage(false)}>
                                    {message}
                                </Alert>
                            )}
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="ibox">

                                        <div className="ibox-content">
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <div className="me-2">
                                                    <select
                                                        value={itemsPerPage}
                                                        onChange={handleItemsPerPageChange}
                                                        className="form-select bg-default p-1"
                                                        style={{ width: 'auto', border: '1px black solid', borderRadius: '5px' }}
                                                    >
                                                        <option value={10}>10</option>
                                                        <option value={20}>20</option>
                                                        <option value={50}>50</option>
                                                    </select>
                                                </div>
                                                <input
                                                    type="text"
                                                    placeholder="Rechercher..."
                                                    className="form-control col-md-3"
                                                    value={searchTerm}
                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                />
                                            </div>

                                            <div className="table-responsive" style={{ fontSize: '11px' }}>
                                                <table className="footable table table-stripped footable-loaded tablet breakpoint" data-page-size="8" data-filter="#filter">
                                                    <thead>
                                                        <tr>
                                                            <th className='text-secondary text-wrap text-center'>
                                                                {/* Case à cocher pour sélection multiple (uniquement pour approbation) */}
                                                                <input
                                                                    type="checkbox"
                                                                    checked={selectedExamenIds.size === currentExamen.length && currentExamen.length > 0}
                                                                    onChange={handleSelectAll}
                                                                    style={{ cursor: 'pointer' }}
                                                                />
                                                            </th>
                                                            <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('date_demande')}>
                                                                Date de demande {sortConfig.key === 'date_demande'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                            <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('date_examen')}>
                                                                Date d'examen {sortConfig.key === 'date_examen'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                            <th className='text-secondary' onClick={() => handleSort('id')}>
                                                                Ref {sortConfig.key === 'id'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                            <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('nom')}>
                                                                Utilisateur {sortConfig.key === 'nom'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                            <th className='text-secondary text-wrap d-none d-md-table-cell text-center' onClick={() => handleSort('type_examen')}>
                                                                Type {sortConfig.key === 'type_examen'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                            <th className='text-secondary text-wrap d-none d-md-table-cell text-center' onClick={() => handleSort('nbre_heures')}>
                                                                Nbre heure {sortConfig.key === 'nbre_heures'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                            <th className='text-secondary text-wrap d-none d-md-table-cell text-center' onClick={() => handleSort('tag')}>
                                                                Tag {sortConfig.key === 'tag'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                            <th className='text-secondary text-wrap d-none d-md-table-cell text-center' onClick={() => handleSort('statut')}>
                                                                Statut {sortConfig.key === 'statut'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                            <th className='text-secondary text-wrap d-none d-md-table-cell text-center' onClick={() => handleSort('motif')}>
                                                                Motif {sortConfig.key === 'motif'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                            <th className='text-secondary text-wrap d-none d-md-table-cell text-center' onClick={() => handleSort('pourcent')}>
                                                                Score {sortConfig.key === 'pourcent'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {!isLoading ? (
                                                            currentExamen.map((examen) => {
                                                                const isExpanded = expandedDescriptions[examen.id];
                                                                const isSelectedForApproval = selectedExamenIds.has(examen.id);
                                                                const isSelectedForRejection = selectedExamen && selectedExamen.id === examen.id;

                                                                return (
                                                                    <tr
                                                                        key={examen.id}
                                                                        onClick={() => handleRowClick(examen)}
                                                                        className={`bg-white ${isSelectedForRejection ? 'bg-success text-white' : ''}`}
                                                                        style={{ cursor: 'pointer' }}
                                                                    >
                                                                        <td className="text-center">
                                                                            {/* Case à cocher pour sélection multiple (uniquement pour approbation) */}
                                                                            <input
                                                                                type="checkbox"
                                                                                checked={isSelectedForApproval}
                                                                                onChange={(e) => {
                                                                                    e.stopPropagation();
                                                                                    handleSelectExamen(examen.id);
                                                                                }}
                                                                                style={{ cursor: 'pointer' }}
                                                                            />
                                                                        </td>
                                                                        <td className="d-none d-md-table-cell">{examen.date_demande}</td>
                                                                        <td className="d-none d-md-table-cell">{examen.date_examen}</td>
                                                                        <td>
                                                                            {examen.id}
                                                                            <div className='lesInfos'>
                                                                                <small>Date de demande : {examen.date_demande}</small><br />
                                                                                <small>Date d'examen : {examen.date_examen}</small><br />
                                                                                <small>Nom et prénoms : {examen.nom}</small><br />
                                                                                <small>Type d'examen : {examen.type_examen}</small><br />
                                                                                <small>Nombres d'heure : {examen.nbre_heures}</small><br />
                                                                                <small>Tag : {examen.tag}</small><br />
                                                                                <small>Statut : {examen.statut}</small><br />
                                                                                <small>Motif : {examen.motif}</small><br />
                                                                                <small style={{ color: examen.pourcent ? (Number(examen.pourcent) < 80 ? 'red' : 'green') : 'inherit' }}>Score :
                                                                                    {examen.total_questions && examen.nombre_correct && examen.pourcent ?
                                                                                        `${examen.nombre_correct}/${examen.total_questions} (${examen.pourcent ? examen.pourcent + '%' : ''})`
                                                                                        : ' '
                                                                                    }
                                                                                </small>
                                                                            </div>
                                                                        </td>

                                                                        <td className="d-none d-md-table-cell">{examen.nom}</td>
                                                                        <td className="d-none d-md-table-cell text-center">{examen.type_examen}</td>
                                                                        <td className="d-none d-md-table-cell text-center">{examen.nbre_heures}</td>
                                                                        <td className="d-none d-md-table-cell text-center">{examen.tag}</td>
                                                                        <td className="d-none d-md-table-cell text-center">
                                                                            {examen.statut === "Approuve" && "Approuvé"}
                                                                            {examen.statut === "Rejete" && "Rejeté"}
                                                                            {examen.statut === "Termine" && "Terminé"}
                                                                            {examen.statut === "En cours de validation" && "En cours de validation"}
                                                                        </td>
                                                                        <td className="d-none d-md-table-cell text-center">{examen.motif}</td>
                                                                        <td className="d-none d-md-table-cell text-center">
                                                                            {examen.total_questions && examen.nombre_correct && examen.pourcent ?
                                                                                `${examen.nombre_correct}/${examen.total_questions} (${examen.pourcent ? examen.pourcent + '%' : ''})`
                                                                                : ' '
                                                                            }
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })
                                                        ) : (
                                                            <div className="mt-3 d-flex justify-content-center align-items-center" style={{ height: '100%', width: '100%' }}>
                                                                <span
                                                                    className="spinner-border spinner-border-lg text-success"
                                                                    role="status"
                                                                    aria-hidden="true"
                                                                    style={{ width: '3rem', height: '3rem' }}
                                                                ></span>
                                                            </div>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                            {/* Pagination Controls */}
                                            <div className="d-flex justify-content-between align-items-center mt-3">
                                                <div className="dataTables_info" role="status" aria-live="polite">
                                                    {sortedExamen.length === 0
                                                        ? "Aucun élément à afficher"
                                                        : `Élément ${indexOfFirstExamen + 1} à ${Math.min(indexOfLastExamen, sortedExamen.length)} sur ${sortedExamen.length}`}
                                                </div>
                                                <div>
                                                    <button
                                                        onClick={() => setCurrentPage(currentPage > 1 ? currentPage - 1 : 1)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === 1}
                                                    >
                                                        <FaArrowLeft />
                                                    </button>

                                                    {(() => {
                                                        const pagesToShow = 5;
                                                        let startPage = Math.max(1, currentPage - Math.floor(pagesToShow / 2));
                                                        let endPage = Math.min(totalPages, startPage + pagesToShow - 1);

                                                        if (endPage - startPage < pagesToShow - 1) {
                                                            startPage = Math.max(1, endPage - pagesToShow + 1);
                                                        }

                                                        const pageButtons = [];

                                                        for (let i = startPage; i <= endPage; i++) {
                                                            pageButtons.push(
                                                                <button
                                                                    key={i}
                                                                    onClick={() => setCurrentPage(i)}
                                                                    className={`btn ${currentPage === i ? 'btn-default' : 'btn-light'} mx-1`}
                                                                >
                                                                    {i}
                                                                </button>
                                                            );
                                                        }

                                                        return pageButtons;
                                                    })()}

                                                    <button
                                                        onClick={() => setCurrentPage(currentPage < totalPages ? currentPage + 1 : totalPages)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        <FaArrowRight />
                                                    </button>

                                                    <button
                                                        onClick={() => setCurrentPage(totalPages)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        {totalPages}
                                                    </button>
                                                </div>
                                                <Modal show={showTelechargerModal} onHide={() => setShowTelechargerModal(false)}>
                                                    <Modal.Header>
                                                        <Modal.Title>Choisir le format de téléchargement</Modal.Title>
                                                    </Modal.Header>
                                                    <Modal.Body>
                                                        <p>Veuillez sélectionner le format du fichier que vous souhaitez télécharger :</p>
                                                        <div className="form-check">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="fileType"
                                                                id="pdfOption"
                                                                value="pdf"
                                                                checked={fileType === "pdf"}
                                                                onChange={() => setFileType("pdf")}
                                                            />
                                                            <label className="form-check-label" htmlFor="pdfOption">
                                                                Télécharger en PDF
                                                            </label>
                                                        </div>
                                                        <div className="form-check">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="fileType"
                                                                id="wordOption"
                                                                value="word"
                                                                checked={fileType === "word"}
                                                                onChange={() => setFileType("word")}
                                                            />
                                                            <label className="form-check-label" htmlFor="wordOption">
                                                                Télécharger en Word
                                                            </label>
                                                        </div>
                                                    </Modal.Body>
                                                    <Modal.Footer>
                                                        <Button variant="secondary" onClick={() => setShowTelechargerModal(false)}>
                                                            Annuler
                                                        </Button>
                                                        {isLoading ? (
                                                            <button className="btn btn-success mr-2" disabled>
                                                                <i className="fa fa-spinner fa-spin mr-1"></i>
                                                                <span className="d-none d-sm-inline ml-2">
                                                                    Chargement...
                                                                </span>
                                                            </button>
                                                        ) : (
                                                            <Button variant="success" onClick={() => handleTelecharger(fileType)}>
                                                                Télécharger
                                                            </Button>
                                                        )}
                                                    </Modal.Footer>
                                                </Modal>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Historique_admin;